import Swiper, { Navigation, Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const carousel = document.querySelector(".c-carousel_feature");
if (carousel) {
  const swiper = new Swiper(carousel, {
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    autoplay: {
        delay: 7000,
    },
    speed: 600,
    pagination: {
      el: ".c-carousel__pagination",
    },
    navigation: {
      nextEl: ".c-carousel_feature__button_next",
    },
  });
}

const cardCarousels = document.querySelectorAll(".c-carousel_cards");
var id = 0;
var cardCarouselArray = [];
cardCarousels.forEach((cardCarousel) => {
  const swiper = cardCarousel.querySelector(".swiper");
  const cardsToShow = cardCarousel.dataset.cardsToShow;
  const paginationEl = cardCarousel.querySelector(
    ".c-card_carousel__pagination"
  );
  const nextButton = cardCarousel.querySelector(
    ".c-carousel_cards__button_next"
  );
  cardCarouselArray[id] = new Swiper(swiper, {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
      500: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      967: {
        slidesPerView: cardsToShow,
        spaceBetween: 20,
      },
    },
    loop: true,
    pagination: {
      el: paginationEl,
    },
    navigation: {
      nextEl: nextButton,
    },
  });

  id++;
});
